import React, { Component } from 'react';
import { withFirebase } from '../../config';
import { Button } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

/*Navbar*/
import OuterHeader from '../Layout/OuterHeader';
import Dashboard from '../Dashboard';
import InnerHeader from '../Layout/InnerHeader';
import NavBar from '../Layout/NavBar';
import Footer from '../Layout/Footer';
/*Redux */
import 'firebase/firestore';
import 'firebase/auth';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
/*Actions */
import {
    saveRadio,
    fetchAllRadio,
    emptyError
} from '../../Actions/RadioActions';
/*Component */
import PublishDate from '../Layout/PublishDate';
import UploadImage from '../S3Uploading/UploadImage';
import UploadAudio from '../S3Uploading/UploadAudio';
import UploadVideo from '../S3Uploading/UploadVideo';

import {ALL_RADIO} from '../../routes'
/*CSS */
import '../../css/AppCss/Series/AddSeries.css';


const INITIAL_STATE = {

    /////////// Radio
    name: '',
    description: '',
    name_in_english: '',
    description_in_english:'',
    publish_date: '',
    error: '',
    imgURL: '',
    audio: '',
    promo_with_music: '',
    promo_without_music: '',
    intro_with_music: '',
    intro_without_music: '',
    featured: false,
    ageFrom: '',
    ageTo: '',
    error: true,
    errorMessage: '',
     ////////////////// cancel Button
     canceled: false
};

class AddRadio extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }


    saveRadio(name, description, imgURL, publish_date, audio,
        promo_with_music, promo_without_music, intro_with_music,
        intro_without_music,name_in_english, description_in_english, featured, ageFrom, ageTo) {

        console.log("saveRadio publish_date = " + publish_date);
        this.props.saveRadio(name, description, imgURL, publish_date, audio,
            promo_with_music, promo_without_music, intro_with_music,
            intro_without_music, name_in_english, description_in_english, featured, ageFrom, ageTo);
    }

    getPublishDate(publishDateTime) {

        if (publishDateTime) {
            this.setState({ publish_date: publishDateTime });
        }
    }

    getImageUrl(imageUrl) {
        if (imageUrl === 'delete') {
            this.setState({
                imgURL: '',
                error: true,
                errorMessage: "Empty Data is not accepted"
            });
        }
        else if (imageUrl !== undefined || imageUrl !== '') {
            this.setState({ imgURL: imageUrl });
            if (this.state.name !== '' &&
                this.state.name !== ' ' &&
                this.state.name !== null 
                // this.state.name_in_english !== '' &&
                // this.state.name_in_english !== ' ' &&
                // this.state.name_in_english !== null
                ) {
                this.setState({ error: false, errorMessage: "" });
            }
        }
        else {
            this.setState({
                imgURL: '',
                error: true,
                errorMessage: "Empty Data is not accepted"
            });
        }
    }

    getPromoWithMusicVideoUrl(videoUrl) {

        if (videoUrl !== "delete") {
            this.setState({ promo_with_music: videoUrl });
            console.log("promo_with_music in Radio = "
                + this.state.promo_with_music);
        }
        else {
            this.setState({ promo_with_music: '' });
        }
    }

    getPromoWithoutMusicVideoUrl(videoUrl) {

        if (videoUrl !== "delete") {
            this.setState({ promo_without_music: videoUrl });
            console.log("promo_without_music in Radio = "
                + this.state.promo_without_music);
        } else {
            this.setState({ promo_without_music: '' });
        }
    }

    getIntroWithoutMusicVideoUrl(videoUrl) {

        if (videoUrl !== "delete") {
            this.setState({ intro_without_music: videoUrl });
            console.log("intro_without_music in Radio = "
                + this.state.intro_without_music);
        } else {
            this.setState({ intro_without_music: '' });
        }
    }


    getIntroWithMusicVideoUrl(videoUrl) {

        if (videoUrl !== "delete") {
            this.setState({ intro_with_music: videoUrl });
            console.log("intro_with_music in Radio = "
                + this.state.intro_with_music);
        } else {
            this.setState({ intro_with_music: '' });
        }
    }

    handleChange = (e) => {
        //
        let checkSpaces = e.target.value.replace(/\s\s+/g, ' ');
        this.setState({ [e.target.name]: checkSpaces });
        let nameOfState = e.target.name;
        setTimeout(() => {
            if ((this.state.imgURL === ''
                || this.state.imgURL === null
                || this.state.imgURL === undefined)
                || (this.state.name === ''
                    || this.state.name === null
                    || this.state.name === ' ')
                || this.state.description_in_english.length > 255    
                // || (this.state.name_in_english === ''
                //     || this.state.name_in_english === null
                //     || this.state.name_in_english === ' ')
                    ) {
                    this.setState({ error: true, errorMessage: nameOfState === "description_in_english" ? 
                        "Description in English is too long (greater than 255 characters)." : 
                        "Empty Data is not accepted" });
            }
            else if ((this.state.imgURL !== ''
                || this.state.imgURL !== undefined)
                && (this.state.name !== null
                    || this.state.name !== ''
                    || this.state.name !== ' ')
                && this.state.description_in_english.length <= 255    
                // && (this.state.name_in_english !== null
                //         || this.state.name_in_english !== ''
                //         || this.state.name_in_english !== ' ')
                        ) {
                this.setState({ error: false, errorMessage: "" });
            }
            else {
                this.setState({
                    error: true,
                    errorMessage: "Empty Data is not accepted"
                });
            }
        }, 0);
    }

    handleCancel = (e) => {
        this.setState({ canceled: true });
    }

    handleSubmit = (e) => {

        const { name, description, publish_date, imgURL, audio,
            promo_with_music, promo_without_music, intro_with_music,
            intro_without_music, name_in_english, description_in_english, featured, ageFrom, ageTo } = this.state;

        if (e.nativeEvent.submitter.id === "saveButton") {
            // Validate age range
            if (ageFrom && ageTo && ageFrom !== '' && ageTo !== '') {
              const fromAge = parseInt(ageFrom);
              const toAge = parseInt(ageTo);
              if (!isNaN(fromAge) && !isNaN(toAge) && toAge < fromAge) {
                alert("Age To must be greater than or equal to Age From");
                e.preventDefault();
                return;
              }
            }

            this.saveRadio(name, description, imgURL, publish_date, audio,
                promo_with_music, promo_without_music, intro_with_music,
                intro_without_music, name_in_english, description_in_english, featured, ageFrom, ageTo);
        }
        // this.closeModal();
        e.preventDefault();


    }

    handleCheckboxChange = () => {
        this.setState({ featured: !this.state.featured })
      };

    getAudio(audioUrl) { // get  Audio
        if (audioUrl) {
            // check if url =  delete send empty to DB
            if (audioUrl === 'delete') {

                this.setState({ audio: '' });
                console.log("audio URL in add Radio  if = "
                    + this.state.audio);
            }
            // else send the url to DB
            else {
                this.setState({ audio: audioUrl });
                console.log("audio URL in add Radio else = "
                    + this.state.audio);

            }

        }
    }


    render() {
        const { error } = this.state;

        const { addingError, success } = this.props;

        const { loading } = this.props;

        if (this.state.canceled === true) {
            return (<Redirect to={ALL_RADIO} ></Redirect>)
        }

        let $buttonSubmitLoader = (
            <div>
                <Button
                    disabled={this.state.error} id="saveButton" >
                    Add
                </Button>
                <Button style={{ float: 'left' }} id="episode_cancel" onClick={this.handleCancel}>
                    Cancel
                </Button>
            </div>);

        if (loading === true) {
            $buttonSubmitLoader = (
                <button id="saveButton"
                    class="ui loading button">
                    Loading</button>);
        }

        if (success === false) {
            alert("error missing data or network " + addingError)
            this.props.emptyError();
        }
        else if (success === true) {
            alert("Radio added Successfully")
            this.props.emptyError();
            this.props.fetchAllRadio();

            this.setState({
                name: '',
                status: '',
                publish_date: '',
                imgURL: '',
                audio: '',
                promo_with_music: '',
                promo_without_music: '',
                intro_with_music: '',
                intro_without_music: '',
                name_in_english: '',
                description_in_english: '',
                featured: false,
            })

            return (<Redirect to={ALL_RADIO} ></Redirect>)

        }

        return (
            <div className="container">
                <OuterHeader />
                <div className="container">
                    <div className="container-body">
                        <div className="row">

                            <Dashboard />
                            <div className="col">
                                <InnerHeader />
                                <div className="main-content">
                                    <div className="row">
                                        <div className="col-12 left-main-body" id="left-main-body">
                                            <NavBar />
                                            <br />
                                            <div className="container">
                                                <h3>Add New Radio</h3>
                                                <hr />


                                                <div className="">
                                                    <form onSubmit={this.handleSubmit.bind(this)}>
                                                        <div className="row">

                                                            {/* image Uploader */}
                                                            <div className="col-md-4 col-12">
                                                                <div className="">
                                                                    <span className="required_input">*</span>
                                                                    <UploadImage
                                                                        getImageURLCallBack={this.getImageUrl.bind(this)}
                                                                        imageUrl={this.state.imgURL}
                                                                        imagepreview={this.state.imgURL}
                                                                        s3DirectryrName='radio' />
                                                                </div>

                                                            </div>

                                                            <div className="col-md-8 col-12">
                                                                <p style={{ color: "red" }}>
                                                                    {this.state.errorMessage} </p>
                                                                <label htmlFor="name" className="label">
                                                                    <span className="required_input">*</span>
                                                                    Name</label>
                                                                <input
                                                                    dir="auto"
                                                                    className="form-control"
                                                                    fluid name="name" id="name" onChange={this.handleChange}
                                                                    value={this.state.name} />
                                                                <br />

                                                                <label htmlFor="name_in_english" className="label">
                                                                    {/* <span className="required_input">*</span> */}
                                                                    Name In English</label>
                                                                <input
                                                                    dir="auto"
                                                                    className="form-control"
                                                                    fluid name="name_in_english" id="name_in_english" onChange={this.handleChange}
                                                                    value={this.state.name_in_english} />
                                                                <br />

                                                                <div className="form-group">
                                                                    <label htmlFor="description"
                                                                        className="label">
                                                                        Description
                                                                    </label>

                                                                    <textarea dir="auto"
                                                                        fluid rows="3"
                                                                        className="form-control"
                                                                        name="description"
                                                                        id="description"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.description} />
                                                                </div>
                                                                <br />

                                                                <div className="form-group">
                                                                    <label htmlFor="description"
                                                                        className="label">
                                                                        Description In English
                                                                    </label>

                                                                    <textarea dir="auto"
                                                                        fluid rows="3"
                                                                        className="form-control"
                                                                        name="description_in_english"
                                                                        id="description_in_english"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.description_in_english} />
                                                                </div>
                                                                <br />

                                                                <label htmlFor="name" className="label">
                                                                    Audio
                                                                </label>

                                                                <UploadAudio
                                                                    getAudioUrlCallBack={this.getAudio.bind(this)}

                                                                    audioPreview={this.state.audio}
                                                                    audioUrl={this.state.audio}
                                                                    s3DirectryrName="radio/audio"
                                                                />

                                                                {/* DateComponent */}
                                                                <PublishDate
                                                                    getPublishDateCallBack={this.getPublishDate.bind(this)}
                                                                    value={this.state.publish_date} />
                                                                <br />
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.featured}
                                                                        onChange={this.handleCheckboxChange}
                                                                    />
                                                                    {' Featured'}
                                                                </label>
                                                                <br />
                                                                
                                                                <div className="form-inline">
                                                                    <div className="col" style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                                                        <label htmlFor="ageFrom" className="label">
                                                                            Age From
                                                                        </label>
                                                                        <br />
                                                                        <input
                                                                            dir="auto"
                                                                            className="form-control"
                                                                            type="number"
                                                                            min="0"
                                                                            name="ageFrom"
                                                                            id="ageFrom"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.ageFrom || ''}
                                                                            fluid
                                                                        />
                                                                    </div>
                                                                    <div className="col" style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                                                        <label htmlFor="ageTo" className="label">
                                                                            Age To
                                                                        </label>
                                                                        <br />
                                                                        <input
                                                                            dir="auto"
                                                                            className="form-control"
                                                                            type="number"
                                                                            min={this.state.ageFrom && this.state.ageFrom !== '' ? parseInt(this.state.ageFrom) : 0}
                                                                            name="ageTo"
                                                                            id="ageTo"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.ageTo || ''}
                                                                            fluid
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        </div>
                                                        {error && <p>{error.message}</p>}
                                                        <label className="label">
                                                            Intro with music</label>
                                                        <div >
                                                            <UploadVideo
                                                                getVideoURLCallBack={this.getIntroWithMusicVideoUrl.bind(this)}
                                                                videoPreview={this.state.intro_with_music}
                                                                videoUrl={this.state.intro_with_music}
                                                                s3DirectryrName='radio'
                                                            />
                                                        </div>
                                                        <br />

                                                        <label className="label">
                                                            Intro without music</label>
                                                        <div >
                                                            <UploadVideo
                                                                getVideoURLCallBack={this.getIntroWithoutMusicVideoUrl.bind(this)}
                                                                videoPreview={this.state.intro_without_music}
                                                                videoUrl={this.state.intro_without_music}
                                                                s3DirectryrName='radio'
                                                            />
                                                        </div>
                                                        <br />

                                                        <label className="label">
                                                            Promo with music</label>
                                                        <div >
                                                            <UploadVideo
                                                                getVideoURLCallBack={this.getPromoWithMusicVideoUrl.bind(this)}
                                                                videoPreview={this.state.promo_with_music}
                                                                videoUrl={this.state.promo_with_music}
                                                                s3DirectryrName='radio'
                                                            />
                                                        </div>
                                                        <br />

                                                        <label className="label">
                                                            Promo without music</label>
                                                        <div >
                                                            <UploadVideo
                                                                getVideoURLCallBack={this.getPromoWithoutMusicVideoUrl.bind(this)}
                                                                videoPreview={this.state.promo_without_music}
                                                                videoUrl={this.state.promo_without_music}
                                                                s3DirectryrName='radio'
                                                            />
                                                        </div>
                                                        <br />

                                                        <div className="input-field">

                                                            {$buttonSubmitLoader}


                                                        </div>
                                                    </form>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>


        )
    }
}


AddRadio.propTypes = {
    saveRadio: propTypes.func.isRequired,
    fetchAllRadio: propTypes.func.isRequired,
}
const mapStateToProps = state => ({
    loading: state.radio.loading,

    radio: state.radio.items,
    addingError: state.radio.error_adding_radio_parent,
    success: state.radio.radio_parent_added_sucessfully
});

export default withFirebase
    (connect
        (mapStateToProps,
            {
                saveRadio,
                emptyError,
                fetchAllRadio
            }
        )
        (AddRadio)
    );